import { translate } from '../services/translate';

const splitCodeError = message =>
    typeof message === 'string'
        ? message?.split('-')[0].replace(/\s/g, '')
        : undefined;

const handleErrorMessage = data => {
    if (!data?.message) {
        return { message: translate('TEXT_ERROROCURRED') };
    }

    const { message, additionalData } = data;

    const codeError = splitCodeError(message);
    let codeErrorMessage = translate(codeError);

    return {
        message: codeErrorMessage
            ? `${codeError} - ${codeErrorMessage}`
            : message,
        additionalData,
    };
};

export { handleErrorMessage };
